import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08d07dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manual-attach" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portrait-bar" }, null, -1))
const _hoisted_3 = { class: "message portrait-text-color" }
const _hoisted_4 = { class: "manual-attach-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_fbx_button, {
        "button-text": "Manual Attach",
        theme: "primaryOutline",
        class: "italic portrait-text-color",
        disabled: _ctx.disabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onManualAttach')))
      }, null, 8, ["disabled"])
    ])
  ]))
}